const base64ToUint8Array = (value) => {
    const binary = globalThis.atob(value);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
};
export const decodeDocumentYjsContent = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    const data = payload;
    if (typeof data.contentBase64 === 'string' && data.contentBase64.length > 0) {
        const bytes = base64ToUint8Array(data.contentBase64);
        return bytes.length > 0 ? bytes : null;
    }
    if (data.content instanceof Uint8Array && data.content.length > 0) {
        return data.content;
    }
    if (Array.isArray(data.content) && data.content.length > 0) {
        return new Uint8Array(data.content);
    }
    return null;
};
//# sourceMappingURL=decode-document-yjs-content.js.map